export default __webpack_public_path__ + "static/samsung-tv-plus-logo-0f94691faed8f8f94d1f7fe7a00ce057.png";